import React from 'react';

import QueryErrors from '~/shared/components/QueryErrors';

import CombinedNotificationsContext from './context';
import useCombinedNotifications from './useCombinedNotifications';

const CombinedNotificationsContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const combinedNotifications = useCombinedNotifications();

  if (combinedNotifications.combinedNotificationsResponse?.error) {
    return <QueryErrors error={combinedNotifications.combinedNotificationsResponse.error} />;
  }

  return (
    <CombinedNotificationsContext.Provider value={combinedNotifications}>
      {children}
    </CombinedNotificationsContext.Provider>
  );
};

export default CombinedNotificationsContextProvider;
